import React, { useState,useEffect } from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import useStyles from './Styles';
import {Owner} from './Inc';
import Ajax from './Ajax';
import Loading from './Loading';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Theme} from './Theme';

interface Props {
    close():void,
    owner:Owner,
    isOpen:boolean,
}

const Commissions:React.FC<Props> = (props)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));

    const [coms,setComs] = useState({
        per_online: -1,
        per_shop: 0,
        per_book: 0,
        per_limit_time: "",
        check_time: "",
        sp_online: false,
        sp_shop: false,
        sp_book: false,
        sp_flag: false,
    })
    const load = ()=>{
        Ajax.send("main/commissions",{owner_id:props.owner.owner_id},(res:any)=>{
            if( res.ok ){
                setComs(res.commissions);
            }
        })
    }
    useEffect( ()=>{
        if(props.isOpen){
            load();
        }
    },[props.isOpen] );

    if( !props.isOpen ){
        return (null);
    }

    if( coms.per_online<0 ){
        return (
            <Loading isLoading={true}/>
        )
    }

    let clOnline = "black";
    let clShop = "black";
    let clBook = "black";
    if( coms.sp_online ){
        clOnline = Theme.palette.secondary.dark;
    }
    if( coms.sp_shop ){
        clShop = Theme.palette.secondary.dark;
    }
    if( coms.sp_book ){
        clBook = Theme.palette.secondary.dark;
    }

	return (
        <Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			fullScreen={fullScreen}
        >
			<DialogTitle color='primary'>{props.owner.owner_name}さんの手数料率</DialogTitle>
			<DialogContent>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell></TableCell>
							<TableCell style={{paddingRight:"0.5em",paddingLeft:"0.5em",textAlign:"center",whiteSpace:"nowrap"}}>オンライン</TableCell>
							<TableCell style={{paddingRight:"0.5em",paddingLeft:"0.5em",textAlign:"center"}}>店舗</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						<TableRow>
							<TableCell style={{paddingRight:"0.5em",paddingLeft:"0"}}>雑貨・本・その他</TableCell>
							<TableCell style={{paddingRight:"0.5em",paddingLeft:"0.5em",textAlign:"center",color:clOnline}}>{coms.per_online}%</TableCell>
							<TableCell style={{paddingRight:"0.5em",paddingLeft:"0.5em",textAlign:"center",color:clShop}}>{coms.per_shop}%</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{paddingRight:"0.5em",paddingLeft:"0"}}>電子書籍</TableCell>
							<TableCell style={{paddingRight:"0.5em",paddingLeft:"0.5em",textAlign:"center",color:clBook}}>{coms.per_book}%</TableCell>
							<TableCell style={{paddingRight:"0.5em",paddingLeft:"0.5em",textAlign:"center"}}></TableCell>
						</TableRow>
					</TableBody>
				</Table>
				<div style={{fontSize:"90%",margin:"0.5em 0",textAlign:"right"}}>
					※{coms.check_time}現在
				</div>
				<div style={{border:"1px solid #EEEEEE",marginTop:"3em",padding:"1em",fontSize:"90%"}}>
					{coms.sp_flag ? (
						<div style={{color:Theme.palette.secondary.dark}}>
						特別な手数料率が設定されています。
						{coms.per_limit_time &&
						<div>
						※{coms.per_limit_time}を過ぎると標準の手数料率に変更されます。
						</div>
						}
						</div>
					):(
						<div>
						標準の手数料率です。
						</div>
					)}
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='閉じる' onClick1={props.close} bottom={0}/>
			</DialogActions>

        </Dialog>

    );
}

export default Commissions;
